import { baseURL } from "Enviroment";
import holzfinderDefaultLotImage from "assets/images/Holzfinder_Los_Platzhalter.jpg";
import { LotImagesFrontendInterface } from "interfaces/LotImagesInterface";
import { useMemo } from "react";

export function useFirstImage(images?: LotImagesFrontendInterface[]) {
  return useMemo(() => getFirstImage(images)
    , [images]);
}

export function getFirstImage(images?: LotImagesFrontendInterface[]) {
  if (images && Array.isArray(images) && images.length > 0) {
    return baseURL + images[0].url;
  } else {
    return holzfinderDefaultLotImage;
  }
}

export function useFirstImageThumbnail(images?: LotImagesFrontendInterface[]) {
  return useMemo(() => getFirstImageThumbnail(images)
    , [images]);
}

export function getFirstImageThumbnail(images?: LotImagesFrontendInterface[]) {
  if (images && Array.isArray(images) && images.length > 0) {
    return baseURL + images[0].thumbnail_url;
  } else {
    return holzfinderDefaultLotImage;
  }
}